import React from "react";

export default function Pricing() {
  return (
    <section className="py-20 bg-[#0c0f2c] text-white">
      <div className="container mx-auto px-4 max-w-6xl">
        <h2
          className="text-center text-yellow-300 font-bold mb-20"
          style={{ fontSize: "44px" }}
        >
          Our Pricing Plans
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Comex Smart Trading */}
          <div className="bg-[#121736] p-6 mb-30 rounded-2xl shadow-lg hover:shadow-purple-500/20 transition-all duration-300">
            <h3 className="text-yellow-300 mb-2" style={{ fontSize: "30px" }}>
              1. Pipplus Core
            </h3>
            <p className="text-gray-300 mb-3" style={{ fontSize: "18px" }}>
              Automated strategies for commodities like gold and silver.
            </p>
            <ul className="list-disc pl-5 text-gray-400 space-y-2" style={{ fontSize: "16px" }}>
              <li>💰 $250 – 3 Months</li>
              <li>💰 $450 – 6 Months</li>
              <li>💰 $700 – 1 Year</li>
            </ul>
          </div>

          {/* Smart Signal Suite */}
          <div className="bg-[#121736] p-6 mb-30 rounded-2xl shadow-lg hover:shadow-purple-500/20 transition-all duration-300">
            <h3 className="text-yellow-300 mb-2" style={{ fontSize: "30px" }}>
              2. Pipplus Pro
            </h3>
            <p className="text-gray-300 mb-3" style={{ fontSize: "18px" }}>
              Premium AI signals with technical analysis delivered in real time.
            </p>
            <ul className="list-disc pl-5 text-gray-400 space-y-2" style={{ fontSize: "16px" }}>
              <li>💰 $500 – 3 Months</li>
              <li>💰 $800 – 6 Months</li>
              <li>💰 $1000 – 1 Year</li>
            </ul>
          </div>

          {/* PipVault Execution */}
          <div className="bg-[#121736] p-6 mb-30 rounded-2xl shadow-lg hover:shadow-purple-500/20 transition-all duration-300">
            <h3 className="text-yellow-300 mb-2" style={{ fontSize: "30px" }}>
              3. Pipplus Prime
            </h3>
            <p className="text-gray-300 mb-3" style={{ fontSize: "18px" }}>
              Designed for latency-sensitive, high-frequency trading execution.
            </p>
            <ul className="list-disc pl-5 text-gray-400 space-y-2" style={{ fontSize: "16px" }}>
              <li>⚡ $700 – 3 Months</li>
              <li>⚡ $1200 – 6 Months</li>
              <li>⚡ $1800 – 1 Year</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
